var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"credit_card"}},[_c('b-container',{staticClass:"simple-content"},[_c('prismic-rich-text',{attrs:{"field":_vm.document.data.review}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }